/**
 * Tabs frontend behavior (nested-tabs SAFE)
 *
 * Initializes tab navigation and content switching
 * for each Tabs block on the page.
 *
 * - Supports nested Tabs blocks
 * - Prevents double initialization
 * - Only processes direct child tab panels
 * - Converts horizontal tabs to dropdown on mobile
 *
 * @return {void}
 */
document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.mu-tabs' ).forEach( ( tabsBlock ) => {
		// Prevent double initialization
		if ( tabsBlock.dataset.tabsInitialized === 'true' ) {
			return;
		}
		tabsBlock.dataset.tabsInitialized = 'true';

		/** @type {HTMLElement|null} */
		const container = tabsBlock.querySelector( ':scope > .container' );
		if ( ! container ) {
			return;
		}

		/** @type {HTMLElement|null} */
		const nav = container.querySelector( ':scope > .mu-tabs__nav' );

		/** @type {HTMLElement|null} */
		const content = container.querySelector( ':scope > .mu-tabs__content' );

		if ( ! nav || ! content ) {
			return;
		}

		/**
		 * Direct child panels only (prevents nested Tabs collision)
		 *
		 * @type {HTMLElement[]}
		 */
		const panels = Array.from( content.children );
		if ( ! panels.length ) {
			return;
		}

		// Reset navigation
		nav.innerHTML = '';

		/** @type {{ button: HTMLButtonElement, panel: HTMLElement, title: string }[]} */
		const tabs = [];

		// ✅ Declare just before usage (lint-safe)
		const isHorizontal = tabsBlock.classList.contains( 'mu-tabs--horizontal' );

		panels.forEach( ( panel, index ) => {
			const title =
				panel.getAttribute( 'data-title' ) ||
				panel.querySelector( ':scope > .mu-tab__title' )?.textContent ||
				`Tab ${ index + 1 }`;

			const button = document.createElement( 'button' );
			button.type = 'button';
			button.textContent = title;
			button.className = 'mu-tabs__tab';

			if ( index === 0 ) {
				button.classList.add( 'is-active' );
				panel.classList.add( 'is-active' );
			}

			button.addEventListener( 'click', () => {
				tabs.forEach( ( t ) => {
					t.button.classList.remove( 'is-active' );
					t.panel.classList.remove( 'is-active' );
				} );

				button.classList.add( 'is-active' );
				panel.classList.add( 'is-active' );

				// Sync dropdown (if exists)
				if ( dropdown ) {
					dropdown.value = String( index );
				}
			} );

			nav.appendChild( button );
			tabs.push( { button, panel, title } );
		} );

		/* ------------------------------------------------
		   MOBILE DROPDOWN (Horizontal Tabs Only)
		------------------------------------------------ */
		let dropdown = null;

		if ( isHorizontal ) {
			dropdown = document.createElement( 'select' );
			dropdown.className = 'mu-tabs__dropdown';

			tabs.forEach( ( tab, index ) => {
				const option = document.createElement( 'option' );
				option.value = String( index );
				option.textContent = tab.title;
				dropdown.appendChild( option );
			} );

			dropdown.addEventListener( 'change', ( e ) => {
				const index = Number( e.target.value );

				tabs.forEach( ( t, i ) => {
					t.button.classList.toggle( 'is-active', i === index );
					t.panel.classList.toggle( 'is-active', i === index );
				} );
			} );

			container.insertBefore( dropdown, nav );
		}
	} );
} );
